import { string, object } from 'yup';

const schema = object().shape({
  text: string()
});

export default schema;
